import React from 'react';
import { Link } from 'react-router-dom';

// Uses the official brain-mark PNG (transparent background) supplied by the client.
const BrandLogo = ({ size = 'md', onClick, to = '/', showTagline = true }) => {
  const sizes = {
    sm: { icon: 44, title: 'text-[18px]',            sub: 'text-[11px]', dash: 'w-3.5', gap: 'gap-2' },
    md: { icon: 60, title: 'text-[24px] sm:text-[28px]', sub: 'text-[13px] sm:text-[15px]', dash: 'w-4',   gap: 'gap-3' },
    lg: { icon: 120, title: 'text-[46px]',           sub: 'text-[24px]', dash: 'w-8',   gap: 'gap-4' },
  };
  const s = sizes[size] || sizes.md;

  const brandFont = "'Poppins', 'Montserrat', 'Inter', sans-serif";

  return (
    <Link to={to} onClick={onClick} className={`flex items-center ${s.gap} group select-none shrink-0`}>
      <img
        src="/assets/logo-mark.png"
        alt="The Brain Theory"
        width={s.icon}
        height={s.icon}
        className="shrink-0 object-contain"
        style={{ width: s.icon, height: s.icon }}
      />
      {showTagline && (
        <div className="leading-none flex flex-col gap-1.5">
          <div
            className={`text-white ${s.title}`}
            style={{ fontFamily: brandFont, fontWeight: 700, letterSpacing: '0.015em', lineHeight: 1 }}
          >
            THE BRAIN
          </div>
          <div className="flex items-center gap-1.5">
            <span className={`h-[2px] ${s.dash} bg-[#F4C430] rounded-full`} />
            <span
              className={`text-white ${s.sub}`}
              style={{ fontFamily: brandFont, fontWeight: 700, letterSpacing: '0.25em', lineHeight: 1 }}
            >
              THEORY
            </span>
            <span className={`h-[2px] ${s.dash} bg-[#F4C430] rounded-full`} />
          </div>
        </div>
      )}
    </Link>
  );
};

export const BrainMark = ({ size = 40, className = '' }) => (
  <img
    src="/assets/logo-mark.png"
    alt="The Brain Theory"
    width={size}
    height={size}
    className={`shrink-0 object-contain ${className}`}
    style={{ width: size, height: size }}
  />
);

export default BrandLogo;
